import { captureException } from '@sentry/nextjs';

// Decoder from Google docs
// https://developers.google.com/identity/gsi/web/guides/display-google-one-tap#javascript
export const decodeJwtResponse = (token: string) => {
	const base64Url = token.split('.')[1];
	const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
	const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
		return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
	}).join(''));

	return JSON.parse(jsonPayload);
}

/**
 * Extract language code from query parameter.
 * Handles string, array of strings, or undefined/null.
 * Splits by '_' and takes the first part (e.g., 'en_US' -> 'en').
 * Defaults to 'en'.
 */
export const getLanguageFromQuery = (lng: any): string => {
	let language = Array.isArray(lng) ? lng[0] : lng;

	if (!language || typeof language !== 'string') {
		language = 'en';
	}

	return language.split('_')[0];
}
